import Action from "../base/action";
import LoadTimeline from "../base/load-timeline";

class StepInstructionMenu extends Action {
    properties;
    until;
    commandActions;
    styleId;
    _commands;
    _timeout;
    rawText;

    constructor(props) {
        super(props);
        this.rawText = props.text;
        this.properties = props;
        this.styleId = props.styleId;
        this._commands = [];
    }

    async execute(eventLoop) {
        const styles = eventLoop.training.resources[this.styleId];
        this.properties.text = this.interpolateVariableValues(eventLoop.training, this.rawText);

        this.properties.buttons.forEach(button => {
            const commandAction = new LoadTimeline({timelines: button.timelines, preserveActionList: [this.type]});
            this._commands.push({
                callback: async () => await commandAction.execute(eventLoop)
            });
        });

        this.commandActions = {
            commands: this._commands
        }

        let styleSubObject = {};
        if (styles && styles.properties) {
            styleSubObject = {
                accentColor: styles.properties.accentColor,
                textColor: styles.properties.textColor,
                backgroundColor: styles.properties.backgroundColor,
                buttonBackgroundColor: styles.properties.buttonBackgroundColor,
                buttonHoverColor: styles.properties.buttonHoverColor,
                opacity: styles.properties.opacity,
                NonVRMode: styles.properties.NonVRMode,
                VRMode: styles.properties.VRMode,
                Camera: styles.properties.Camera,
                Scene: styles.properties.Scene,
                buttons: styles.properties.buttons
            }
        }

        let stepMenuFrameProps = {};
        if (eventLoop.training.stepMenuFrame) {
            const stepMenuFrame = eventLoop.training.stepMenuFrame;

            stepMenuFrameProps = {
                ...(stepMenuFrame.VRMode && { VRMode: stepMenuFrame.VRMode }),
                ...(stepMenuFrame.Scene && { Scene: stepMenuFrame.Scene }),
            };
        }

        const mergedButtons = this.properties.buttons.map(btn => {
            const styleBtn = styleSubObject.buttons.find(b => b.name === btn.name);
            return {
                ...btn,
                icon: btn.icon ?? styleBtn?.icon
            };
        });

        const merged = {...styleSubObject, ...stepMenuFrameProps, ...this.properties, ...this.commandActions, buttons: mergedButtons};

        const tempController = await InstructionManager.AddNewInstructionMenu(merged);

        if (!eventLoop.training.loadingStateWithStepMenu) {
            // check and destroy previous running action
            const actions = eventLoop.getActionsByClassName(this.type);
            if (actions.length) {
                await eventLoop.pruneActionsByClass([this.type]);
            }
        }

        InstructionManager.updateButtonAndToolbarPosition(true);
        this.instructionMenuController = tempController;
        this.instructionMenuController.applyStepMenuFrameToMenu(eventLoop.training.stepMenuFrame);
    }

    async stop() {
        InstructionManager.RemoveInstructionMenu(this.instructionMenuController);
        InstructionManager.updateButtonAndToolbarPosition(false);
    }
}

export default StepInstructionMenu;
